<template>
  <v-btn
    style="
      z-index: 1002;
      position: absolute;
      top: 16px;
      right: 18px;
      font-family: 'Public Sans';
      font-size: 12px;
      font-style: normal;
      font-weight: 300;
      line-height: normal;
      letter-spacing: -0.12px;
    "
    :style="hasFilteredNetworks ? `border: 1px solid #6DC6FF` : ``"
    :small="smAndUp"
    :class="smAndUp ? 'rounded-pill text-none px-6' : ''"
    :color="hasFilteredNetworks ? (smAndUp ? '#C0E7FF' : 'white') : undefined"
    @click="openNetworkSettings"
    :icon="xs ? true : false"
    density="compact"
    height="30px"
    elevation="5"
  >
    <v-icon color="pwt_black"> mdi-filter-variant </v-icon>
    <span v-if="smAndUp" class="text-pwt_black"> Networks </span>
  </v-btn>
</template>
<script setup lang="ts">
import { MutationTypes, SecondaryDialogContent } from '@/store/store_types'
import { computed } from 'vue'
import { useDisplay } from 'vuetify'
import { useStore } from 'vuex'

const { smAndUp, xs } = useDisplay()

const store = useStore()

const hasFilteredNetworks = computed(() => !!store.state.networkSelectionOverride)

const openNetworkSettings = () => {
  store.commit(MutationTypes.setSecondaryDialogContent, SecondaryDialogContent.NETWORK_SETTINGS)
}
</script>
